import "./jquery-global";
import "jquery-ui/dist/jquery-ui.js";
import {DefaultMessages} from "@/localization/DefaultMessages";
import {DefaultSessionRepository} from "@/network/repository/impl/DefaultSessionRepository";
import {LoginPage} from "@/pages/LoginPage";
import {ExclaimApplication} from "@/ExclaimApplication";
import {EX} from "@/exclaim";
import "material-icons/iconfont/filled.css";

// This is a simplified version of initialization that doesn't load everything
// to reduce the loading impact of the login page on the server (by all the
// things that probe the server).
async function startApplication(): Promise<void> {
    if (!(EX instanceof ExclaimApplication)) {
        throw new TypeError("EX object is not an ExclaimApplication object -- something is very wrong.");
    }
    const app = EX;

    try {
        // Initialize the localization system (EX.Messages) early as lots of things depend on it
        const messages = new DefaultMessages({ locale: app.locale})
        app.messages = messages;
        try {
            await messages.load();
        } catch (err) {
            console.error("Error during message loading: %s", err);
            // Continue with initialization even though some things might not work correctly
        }

        const page = new LoginPage(app.messages, new DefaultSessionRepository());
        await page.init();
    } catch (err) {
        // Log any startup error to the console so we can have a chance at debugging / seeing issues
        console.error(err);
    }
}

// This is an entry point file, so we need to register load handler here
globalThis.addEventListener('load', startApplication);
